import { render, staticRenderFns } from "./city-list.vue?vue&type=template&id=1bbc6382&"
import script from "./city-list.vue?vue&type=script&lang=js&"
export * from "./city-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports